/** Tailwind-классы типографики брендбука для блоков лендинга. */

export const landingFont =
  "[font-family:var(--landing-font-family,Arial,Helvetica,sans-serif)]";

export const landingH1 =
  `${landingFont} text-[length:var(--landing-type-h1,40px)] font-bold leading-[1.15] tracking-tight text-[var(--color-text-primary)]`;

export const landingH2 =
  `${landingFont} text-[length:var(--landing-type-h2,30px)] font-bold leading-tight text-[var(--color-text-primary)]`;

export const landingH3 =
  `${landingFont} text-[length:var(--landing-type-h3,18px)] font-bold leading-snug text-[var(--color-text-primary)]`;

export const landingBody =
  `${landingFont} text-[length:var(--landing-type-body,18px)] font-normal leading-relaxed text-[var(--color-text-secondary)]`;

export const landingBodyLg =
  `${landingFont} text-[length:var(--landing-type-body-lg,22px)] font-normal leading-relaxed text-[var(--color-text-primary)]`;

export const landingOverline =
  `${landingFont} text-[length:var(--landing-type-overline,20px)] font-normal leading-[1.55] text-[var(--color-text-primary)]`;

export const landingButtonText =
  `${landingFont} text-[length:var(--landing-type-button,16px)] font-normal`;

/** Акцент в заголовках (#E11D48), не hover-меню. */
export const landingAccentText =
  "text-[var(--landing-accent-deep,var(--landing-accent,#E11D48))]";

export const landingAccentFallback = "#E11D48";
